import { type ComponentProps, type FC } from 'react';

import clsx from 'clsx';

import styles from './Grid.module.scss';

type GridProps = ComponentProps<'div'> & {
  gap?: number;
  rowGap?: number;
  colGap?: number;
  template?: string;
  columnsTemplate?: string;
  rowsTemplate?: string;
  alignItems?: 'start' | 'center' | 'end' | 'stretch';
  justifyItems?: 'start' | 'center' | 'end' | 'stretch';
};

export const Grid: FC<GridProps> = (props) => {
  const {
    className,
    gap,
    rowGap,
    colGap,
    template,
    columnsTemplate,
    rowsTemplate,
    alignItems,
    justifyItems,
    style,
    ...restProps
  } = props;

  return (
    <div
      className={clsx(
        styles.root,
        alignItems && styles[`alignItems_${alignItems}`],
        justifyItems && styles[`justifyItems_${justifyItems}`],
        className
      )}
      style={{
        rowGap: typeof rowGap === 'number' ? rowGap * 4 : undefined,
        columnGap: typeof colGap === 'number' ? colGap * 4 : undefined,
        ...(typeof gap === 'number' ? { gap: gap * 4 } : {}),
        ...(template
          ? { gridTemplate: template }
          : {
              gridTemplateColumns: columnsTemplate,
              gridTemplateRows: rowsTemplate,
            }),
        ...style,
      }}
      {...restProps}
    />
  );
};
